export default "/images/9d94dac1a831e4a3257b6170f5033bc5.avif";